import { CNavLink } from '../CNavLink';
import { useActiveLeague } from '../../hooks/useActiveLeague';
import { useLocation } from 'react-router-dom';
import TutorialTooltip from '../common/TutorialTooltip';

function TransfersPageNav() {
  const { activeLeague } = useActiveLeague();
  const { search } = useLocation();

  return (
      <div className="onpage-nav-block">
          <ul className="onpage-nav">
                <TutorialTooltip
                  id="transfers-nav-tooltip"
                  title="Transfers by status"
                  description="You can switch between all players, your ongoing transfer negotiations and the players you’ve signed."
                  className="f-right"
                />

              {/*<CNavLink to={activeLeague ? `/${activeLeague.slug}/transfers-shortlist${search}` : '#'} active={[`transfers-shortlist`]}>*/}
              {/*    Shortlist*/}
              {/*</CNavLink>*/}
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/transfers-players${search}` : '#'} active={[`transfers-players`]}>
                  Players
              </CNavLink>
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/transfers-ongoing${search}` : '#'} active={[`transfers-ongoing`]}>
                  Ongoing
              </CNavLink>
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/transfers-signed${search}` : '#'} active={[`transfers-signed`]}>
                  Signed
              </CNavLink>
          </ul>

      </div>
  )
}

export {TransfersPageNav}
